module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "hear-from-you.d09edf17.webp" + "?" + Date.now();